import { Button } from '@/components/ui/button'
import useTranslator from '@/hooks/translation'
import { useHeaderAction } from '@/stores'

export const NewCampaignAction = () => {
  const { getTranslation } = useTranslator()
  const { setAction } = useHeaderAction()

  const handleClick = () => {
    setAction('campaign-module:new-campaign')
  }

  return (
    <Button variant="fintalk" size="sm" onClick={handleClick}>
      {getTranslation('campaignModule.campaigns.newCampaign')}
    </Button>
  )
}
